import axios from 'axios';
import store from '../store';
import frontendLogService from './frontendLogService';

const IgnoredUrl = ["api/designers"];

axios.interceptors.request.use(function (config) {
  // Don't add Bearer token for OO service URLs
  if (config.url.includes('/public/')) {
    return config;  // Let the original headers pass through
  }

  // Add Bearer token for all other requests
  const tkn = getToken();
  if (tkn) {
    config.headers.Authorization = "Bearer " + getToken();
  }
  return config;
});

axios.interceptors.response.use((response) => response, (error) => {
  const {memberId, designId} = store.getState();

  let message = error.message;
  let stack = error.stack;

  let url = "";
  let status = "";
  if (error.request) {
    url = error.request.responseURL;
    status = error.request.status;
  }

  if (IgnoredUrl.find(it => url.indexOf(it) > -1)) {
    return;
  }

  frontendLogService.log(memberId, designId, `URL=${url} \nSTATUS=${status} \nMESSAGE=${message} \nSTACK=${stack}`);
});

function getToken() {
  return window.localStorage.getItem('tkn');
}
